import { environment } from '@app/env';
import { Component } from '@angular/core';
import { AppPopoversService } from '../../app-popovers/app-popovers.service';

@Component({
  selector: 'app-footer-desktop',
  styleUrls: ['app-footer-desktop.component.scss'],
  templateUrl: './app-footer-desktop.component.html'
})
export class AppFooterDesktopComponent {
  public env = environment;

  constructor(private appPopoversService: AppPopoversService) {}
  public showPopup(id) {
    this.appPopoversService.open(id);
  }
}
